import React, { useRef } from "react";

import { useIntl } from "react-intl";

import * as S from "./style";
import Portal from "./Tooltip.portal";

const MARGIN = 20;

const calculatePosition = (pointerX, pointerY, tooltipRect?: DOMRect) => {
  const defaults = { width: 260, x: pointerX, height: 0 };

  const { width, height } = tooltipRect || defaults;
  let tooltipY = pointerY - Math.round(height / Math.PI);

  const hasLeftSpace = pointerX - width - MARGIN > 0;
  const hasRightSpace =
    !hasLeftSpace && pointerX + width + MARGIN < document.body.offsetWidth;

  let tooltipX = hasLeftSpace ? pointerX - width - MARGIN : pointerX + MARGIN;

  if (!hasLeftSpace && !hasRightSpace) {
    tooltipX = pointerX - width / 2;
    tooltipY = pointerY - height - MARGIN;
  }
  return { transform: `translate(${tooltipX}px, ${tooltipY}px)` };
};

const Tooltip = ({
  x,
  y,
  isVisible,
  forwardedRef,
  maxZoom = false,
  children
}) => {
  const intl = useIntl();
  const tooltip = useRef<HTMLDivElement>(null);

  const transform = calculatePosition(
    x,
    y,
    tooltip?.current?.getBoundingClientRect()
  );

  return (
    <Portal forwardedRef={forwardedRef}>
      <S.Layout
        isVisible={!!(isVisible && transform)}
        style={transform}
        ref={tooltip}
      >
        {maxZoom ? (
          <S.Text>
            {intl.formatMessage({
              id: "metrics.info.zoom",
              defaultMessage: "Maximum zoom has been reached"
            })}
          </S.Text>
        ) : (
          children
        )}
      </S.Layout>
    </Portal>
  );
};

export default React.memo(Tooltip);
